import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import SectionContainer from '../LandingPage/components/section/SectionContainer'
import LPContainer from './LPContainer'

const BenefitSection: FCC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t('solutions:cross_functional:section_1_content_title'),
      contentDescription: t(
        'solutions:cross_functional:section_1_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionCross01.png',
      direction: 'ltr',
      contentLink: '#'
    },
    {
      contentTitle: t('solutions:cross_functional:section_2_content_title'),
      contentDescription: t(
        'solutions:cross_functional:section_2_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionCross02.png',
      direction: 'rtl',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="solutions:title01"
      // tagLabel="solutions:tag"
      // tagColor="bg-purple-100 text-purple-800"
      className="pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0">
      <LPContainer className="mt-6 space-y-10 px-0 tablet:px-4">
        {SECTIONS.map((item, index) => {
          return (
            <div
              key={index}
              className={cn(
                'items-center flex flex-col tablet:flex-row',
                item.direction === 'ltr' ? '' : 'tablet:flex-row-reverse'
              )}>
              <div
                className={cn(
                  'flex-1 mb-20 tablet:mb-0',
                  item.direction === 'ltr' ? 'tablet:mr-20' : 'tablet:ml-20'
                )}>
                <TypographyText className="text-[23px] font-medium text-gray-900">
                  {item.contentTitle}
                </TypographyText>
                <TypographyText className="text-base font-normal text-gray-700 mt-3">
                  {item.contentDescription}
                </TypographyText>
              </div>

              <div className="bg-gray-100">
                <img
                  src={item.contentImage}
                  alt={`screenshot ${index}`}
                  className="tablet:max-w-[495px] max-w-full"
                />
              </div>
            </div>
          )
        })}
      </LPContainer>
    </SectionContainer>
  )
}

export default BenefitSection
